import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// ─────────────────────────────────────────────────────────────────────────────
// RecaptchaBoundary
//
// Scopes the reCAPTCHA v3 provider (and the Google script it injects) to ONLY
// the routes that actually use reCAPTCHA — currently the Contact form and the
// Client login/register page.
//
// Previously GoogleReCaptchaProvider wrapped the entire app in App.js, so the
// reCAPTCHA script loaded on EVERY page, including marketing / ad-landing pages
// (Home, /portfolio). On load, reCAPTCHA runs Web-Crypto bot-scoring, which
// throws a benign `OperationError: Non-recoverable error. Do not retry.` inside
// restricted in-app webviews (notably the Facebook in-app browser on Android).
// That was reported to Sentry on paid/social traffic landing on those pages.
// Loading reCAPTCHA only where it's needed removes that noise at the source and
// keeps the reCAPTCHA badge off pages that never invoke it.
//
// Safety: the consuming components (Contact.js, ClientLogin.jsx) already guard
// with `if (executeRecaptcha)` and soft-allow when it's absent, so scoping the
// provider can never hard-block a submission — worst case is a token-less submit
// (the same Pack N tradeoff), which the server already handles.
// ─────────────────────────────────────────────────────────────────────────────
export default function RecaptchaBoundary({ children }) {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
      scriptProps={{ async: true, defer: true, appendTo: 'head' }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
